<template>
  <div class="language-toggle">
    <button 
      class="lang-btn" 
      :class="{ active: currentLang === 'en' }"
      @click="changeLang('en')"
    >
      EN
    </button>
    <button 
      class="lang-btn" 
      :class="{ active: currentLang === 'es' }"
      @click="changeLang('es')"
    >
      ES
    </button>
  </div>
</template>

<script>
export default {
  name: 'LanguageToggle',
  props: {
    currentLang: {
      type: String,
      required: true
    }
  },
  methods: {
    changeLang(lang) {
      this.$emit('change-lang', lang);
    }
  }
}
</script>

<style scoped>
.language-toggle {
  position: fixed;
  top: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.5rem;
  z-index: 1000;
}

.lang-btn {
  padding: 0.5rem 1rem;
  border: 2px solid #42b983;
  border-radius: 8px;
  background: white;
  color: #42b983;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lang-btn:hover {
  background: #42b983;
  color: white;
}

.lang-btn.active {
  background: #42b983;
  color: white;
}
</style> 